import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'globot-spinner-check',
  template: `
    <!-- Lápiz cuando no está en modo edición -->
    <div *ngIf="!isEditing" class="edit-icon">
      <i
        class="pi pi-pencil"
        [ngClass]="{ 'disabled-icon': isDisabled }"
        (click)="onEditClick()"
        [pTooltip]="editTooltip"
        tooltipPosition="top"
      >
      </i>
    </div>

    <!-- Contenedor de iconos de edición -->
    <div *ngIf="isEditing" class="edit-actions">
      <!-- Spinner durante la carga -->
      <i *ngIf="isLoading" class="pi pi-spinner pi-spin" styles="color:#E2E8F0"> </i>

      <!-- Check de éxito -->
      <i *ngIf="isSuccess && !isLoading" class="pi pi-check" [style.color]="successColor"> </i>

      <!-- Iconos de guardar y cancelar cuando no está cargando ni mostrando éxito -->
      <ng-container *ngIf="!isLoading && !isSuccess">
        <i
          class="pi pi-check save-icon"
          [style.color]="successColor"
          (click)="save.emit()"
          [pTooltip]="saveTooltip"
          tooltipPosition="top"
        >
        </i>
        <i
          class="pi pi-times cancel-icon"
          [style.color]="errorColor"
          (click)="cancel.emit()"
          [pTooltip]="cancelTooltip"
          tooltipPosition="top"
        >
        </i>
      </ng-container>
    </div>
  `,
  styleUrls: ['./spinner-check.component.scss'],
})
export class SpinnerCheckComponent {
  @Input() isDisabled = false;
  @Input() isLoading = false;
  @Input() isSuccess = false;
  @Input() isEditing = false;
  @Input() successColor = '#3CC13B';
  @Input() errorColor = '#EF4444';
  @Input() editTooltip = 'Editar';
  @Input() saveTooltip = 'Guardar';
  @Input() cancelTooltip = 'Cancelar';

  @Output() edit = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onEditClick() {
    this.edit.emit();
  }
}
